<template>
  <div class="definition-component">
    <div class="definition" v-bind:class="{ active: isActive }" @click.self="selectDefinition">
      <a-tooltip placement="top">
        <template slot="title">
          <span>Relaties weergeven</span>
        </template>
        <a-checkbox v-show="shouldDisplayCheckbox" @change="onChange"/>
      </a-tooltip>
      {{ definition.name }}
    </div>
    <div class="relations" v-show="displayRelations">
      <div v-for="(relationDefinition, key) in relationDefinitions" :key="key" class="item">
        <DefinitionComponent :definition="relationDefinition" :parent-definition="definition"
                             @selectDefinition="selectChildDefinition"></DefinitionComponent>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from '../store';
import templatingApi from '~/api/templating';
import ValueComponent from "~/modules/templating/components/ValueComponent";

export default {
  name: "DefinitionComponent",
  props: {
    definition: {
      type: Object,
      required: true
    },
    parentDefinition: {
      type: Object,
      required: false
    },
    displayRelationsInitially: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    definition: function (newVal, oldVal) {
      this.relationsLoaded = false;
      this.relationDefinitions = [];
      this.initRelations();
    }
  },
  data() {
    return {
      displayRelations: false,
      loadRelations: false,
      relationsLoaded: false,
      relationDefinitions: [],
    }
  },
  computed: {
    ...mapGetters({
      selectedDefinition: '$_templating/selectedDefinition',
      isActive: '$_templating/selectedDefinition',
    }),
    shouldDisplayCheckbox() {
      return typeof this.parentDefinition !== "undefined" || !this.displayRelationsInitially;
    },
    isActive() {
      return store.state.selectedDefinition == this.definition;
    }
  },
  created() {
    const STORE_KEY = '$_templating';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {
    this.loadRelations = (typeof this.parentDefinition === "undefined");
    this.displayRelations = this.loadRelations && this.displayRelationsInitially;

    if (this.loadRelations && this.displayRelationsInitially) {
      this.initRelations();
    }
  },
  components: {
    ValueComponent
  },
  methods: {
    selectDefinition() {
      this.$emit('selectDefinition', this.definition, this.parentDefinition);
    },
    selectChildDefinition(definition, parentDefinition) {
      this.$emit('selectDefinition', definition, parentDefinition);
    },
    onChange(event) {
      this.loadRelations = event.target.checked;
      this.displayRelations = event.target.checked;

      if (this.loadRelations) {
        this.initRelations();
      }
    },
    initRelations() {
      if (!this.relationsLoaded) {
        this.definition.relations.data.forEach(relation => {
          templatingApi.getDefinitionByDefinitionClass(relation.definition_class).then(response => {
            let relationDefinition = response.data;
            relationDefinition.name = relation.key;
            relationDefinition.relationKey = this.definition.prefix + '_' + relation.key;
            relationDefinition.parentRelation = relation;
            relationDefinition.parentDefinition = this.definition;
            this.relationDefinitions.push(relationDefinition);
          });
        });
        this.relationsLoaded = true;
      }
    }
  }
}
</script>
<style scoped>
.definition-component {
  margin-bottom: .5rem;
}

.definition {
  border: solid 1px #ccc;
  border-radius: .5rem;
  padding: 1.5rem 1rem;
  cursor: pointer;
}

.definition.active {
  background-color: #1a8ffc;
  color: white;
  border: solid 1px #0479e7;
  cursor: default;
}

.definition:not(.active):hover {
  background-color: #f1f1f1;
}

.relations {
  padding: 1rem 1.5rem;
}

.relations .item {
  margin-bottom: .5rem;
}
</style>